import React from "react";

import AppNavbar from "../AppNavbar/AppNavbar";
import AppFooter from "../AppFooter/AppFooter";

import "./Layout.css";

const Layout = (props) => (
	<React.Fragment>
		<AppNavbar />
		{props.children}
		<AppFooter />
	</React.Fragment>
);

export default Layout;
